import React from "react";

import Container from "@material-ui/core/Container";

import { AppContainer } from "./AppContainer";
import { ContextProvider } from "./contexts/Context";

import "./App.css";

function App() {
  return (
    <>
      <Container>
        <ContextProvider>
          <AppContainer />
        </ContextProvider>
      </Container>
    </>
  );
}

export default App;
